import { v4 as uuidv4 } from "uuid";
import { TrackedAction } from "../data/Tracking";
import { Api } from "../utils/Api";
import { has3rdPartyCookiesEnabled } from "../utils/ThirdPartyCookies";

export const trackApplicationLoad = (param: TrackedAction): void => {
    if (param.domain) {
        Api.Get().SaveTrackedAction(param);
    }
}

export const trackLockerSelected = (param: TrackedAction): void => {
    if (param.domain && param.lockerId) {
        Api.Get().SaveTrackedAction(param);
    }
}

export const trackLockerFavourite = (param: TrackedAction): void => {
    if (param.domain && param.lockerId) {
        Api.Get().SaveTrackedAction(param);
    }
}

export const trackApplicationClosed = (param: TrackedAction): void => {
    if (param.domain) {
        Api.Get().SaveTrackedAction(param);
    }
}

export const getCorrelationId = (contextCorrelationId: string): string => {
    if(!has3rdPartyCookiesEnabled()){
        return contextCorrelationId;
    }

    let correlationId = window.sessionStorage.getItem("correlationId");
    if (correlationId === null) {
        correlationId = uuidv4();
        window.sessionStorage.setItem("correlationId", correlationId);
    }
    return correlationId
}